<template>
  <MemoForm memo="" />
</template>

<script>
import MemoForm from '@/components/MemoForm.vue'
export default {
  name: 'NewView',
  components: {
    MemoForm
  }
}
</script>
